import React, {useEffect} from 'react';
import Typography from '@mui/material/Typography';
import {withStyles} from '@mui/styles';
import moment from 'moment';
import {connect} from 'react-redux';
import {selectors as opportunitySelectors} from '../../../../Ducks/opportunity';

const useStyles = _ => ({
    card: {
        backgroundColor: '#fff'
    },
    cardActions: {
        display: 'flex',
        flexDirection: 'row-reverse',
        marginRight: '-8px',
        marginBottom: '-8px'
    },
    box: {
        width: "19px",
        height: "19px",
        borderColor: "#cacaca",
        borderStyle: "solid",
        marginRight: "5px"
    },
    none: {
        background: 'transparent',
    },
    unknown: {
        background: 'yellow'
    },
    attending: {
        background: 'green',
    },
    not_attending: {
        background: 'red',
    },
    tentative: {
        background: 'yellow',
    }
});

function NextPlannedAction(props) {
    const {opportunity, plannedAction} = props;
    const [action, setAction] = React.useState({});

    useEffect(() => {
        // The saved NPA in the store is newer than the open opportunity loaded with the person, so it wins
        if (opportunity && plannedAction && plannedAction.opportunity_id == opportunity.opportunity_id) {
            setAction(plannedAction)
        } else if (opportunity && opportunity.opportunity_actions) {
            setAction(opportunity.opportunity_actions || {})
        } else {
            setAction({})
        }
    }, [opportunity, plannedAction]);

    return (
        <>
            <div>
                <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                    <Typography variant="h6" component="div" gutterBottom>
                        Planned
                        Action
                    </Typography>
                </div>
                <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                    {
                        action && action.opportunity_action_due_time && (
                            <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                                <Typography variant="body2" color="site.main" gutterBottom style={{margin: ' 0 5px 0 0'}}>
                                    <b>{moment(action.opportunity_action_due_time).format("DD/MM/YYYY HH:mm")}</b>
                                </Typography>
                            </div>
                        )
                    }
                </div>
                {
                    !action.opportunity_action_type &&
                    <Typography variant="body2" color="site.main">
                        There is no planned action for this opportunity
                    </Typography>
                }
            </div>
        </>
    );
}

const mapStateToProps = (state) => ({
    plannedAction: opportunitySelectors.plannedActionResponse(state),
});

export default connect(mapStateToProps)(withStyles(useStyles)(NextPlannedAction));